import { render, staticRenderFns } from "./ComponenteSolicitacaoListagem.vue?vue&type=template&id=1204affb"
import script from "./ComponenteSolicitacaoListagem.vue?vue&type=script&lang=js"
export * from "./ComponenteSolicitacaoListagem.vue?vue&type=script&lang=js"
import style0 from "./ComponenteSolicitacaoListagem.vue?vue&type=style&index=0&id=1204affb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports